import TIM from "tim-js-sdk";
import { post } from "@/util/http";
import { store } from "@/store/index.js";
import Vue from "vue";
import { format } from "@/util/time";
import { i18n } from "@/main.js";

export let tim = null;
export function initTim() {
  console.log(store.state.appConfig.im_sdkappid, "store.state");
  let options = {
    SDKAppID: Number(store.state.appConfig.im_sdkappid),
  };
  // 创建 SDK 实例，`TIM.create()`方法对于同一个 `SDKAppID` 只会返回同一份实例
  if (tim == null) {
    tim = TIM.create(options); // SDK 实例通常用 tim 表示
    // tim.setLogLevel(0); // 普通级别，日志量较多，接入时建议使用
    tim.setLogLevel(1); // release 级别，SDK 输出关键信息，生产环境时建议使用
    tim.on(TIM.EVENT.SDK_READY, timOnSdkReady);
    tim.on(TIM.EVENT.MESSAGE_RECEIVED, timOnMessageReceived);
    tim.on(TIM.EVENT.MESSAGE_MODIFIED, timOnMessageModified);
    tim.on(TIM.EVENT.ERROR, timOnError);
    tim.on(TIM.EVENT.KICKED_OUT, onKickedOut);
  }
  loginTim();
}

function timOnError(event) {
  console.log("timOnError", event.data);
}

//被踢下线
function onKickedOut(event) {
  // Vue.prototype.$message.error("聊天室已离线，请刷新重新登录");

  console.log("被踢下线", event.data.type);
  store.commit("toggleTimReady", false);
  store.commit("changeLoginRepData", {});
  tim.destroy().then(() => {
    console.log("sdk destroyed");
  });
}

function loginTim() {
  if (store.state.userInfo.id) {
    userLoginTim(String(store.state.userInfo.id), store.state.userInfo.sig);
  } else {
    getUserSig();
  }
}
async function getUserSig() {
  const { data } = await post({ url: "/api/tencentIm/getUserSig" });
  console.log(data);
  if (data.status == 0) {
    userLoginTim(data.data.id, data.data.sig);
  }
}
function userLoginTim(uid, sig) {
  let promise = tim.login({ userID: uid, userSig: sig });
  promise
    .then((imResponse) => {
      console.log(imResponse.data, "登录TIM成功"); // 登录成功
      if (imResponse.data.repeatLogin === true) {
        console.log(imResponse.data.errorInfo, "重复TIM登录");
      }
    })
    .catch((imError) => {
      console.warn("login error:", imError, imError.code); // 登录失败的相关信息
      if (imError.code === 70001) {
        store.commit("changeUserInfo", {
          id: "",
          diamond: 0,
          gold: 0,
        });
        localStorage.removeItem("userInfo");
        localStorage.removeItem("token");
        localStorage.removeItem("id");
        if (!store.state.showLogin) {
          store.commit("toggleLogin");
        }
      }
    });
}
function timOnSdkReady() {
  store.commit("toggleTimReady", true);
  console.log("onSdkReady", store.state.isTimReady);
  if (store.state.userInfo.id) {
    updateMyProfile();
  }
}

function updateMyProfile() {
  // 修改个人标配资料
  let promise = tim.updateMyProfile({
    nick: store.state.userInfo.nick_name,
    avatar: store.state.userInfo.avatar,
  });
  promise
    .then(function (imResponse) {
      console.log(imResponse.data, "更新资料成功"); // 更新资料成功
    })
    .catch(function (imError) {
      console.warn("updateMyProfile error:", imError); // 更新资料失败的相关信息
    });
}

let roomId = 0;
export async function timJoinGroup(room, nickname) {
  console.log(room, nickname, "room+++++++++++++++++++++++++++++++++=");
  roomId = room;
  let imResponse = await tim.joinGroup({
    groupID: String(room),
    type: TIM.TYPES.GRP_AVCHATROOM,
  });
  console.log(imResponse, "imResponse");
  let systemTipText = "";
  switch (imResponse.data.status) {
    case TIM.TYPES.JOIN_STATUS_WAIT_APPROVAL: // 等待管理员同意
      console.log("等待管理员同意");
      break;
    case TIM.TYPES.JOIN_STATUS_SUCCESS: // 加群成功
      console.log(imResponse.data, "加群成功"); // 加入的群组资料
      systemTipText = `系统提示：欢迎来到（${
        nickname || ""
      }）的直播间，喜欢就点关注吧。猎鹰直播依法对直播内容进行24小时巡查，禁止传播违法违规、封建迷信、暴力血腥、低俗色情、招嫖诈骗违禁品等不良信息，坚决维护青少年群体精神文明健康。请勿轻信各类招聘征婚、代练代抽、刷钻、购买礼包码、游戏币等广告信息。且如主播在推广商品中诱导私下交易，请谨慎判断，以免上当受骗。`;
      loginRequest(room);
      timSendPing(room);
      return systemTipText;
    case TIM.TYPES.JOIN_STATUS_ALREADY_IN_GROUP: // 已经在群中
      console.log("已经在群中");
      loginRequest(room);
      systemTipText = `系统提示：欢迎来到（${
        nickname || ""
      }）的直播间，喜欢就点关注吧。猎鹰直播依法对直播内容进行24小时巡查，禁止传播违法违规、封建迷信、暴力血腥、低俗色情、招嫖诈骗违禁品等不良信息，坚决维护青少年群体精神文明健康。请勿轻信各类招聘征婚、代练代抽、刷钻、购买礼包码、游戏币等广告信息。且如主播在推广商品中诱导私下交易，请谨慎判断，以免上当受骗。`;
      return systemTipText;
  }
}

let pingTimer = null;
function timSendPing(room) {
  if (pingTimer) {
    clearInterval(pingTimer);
  }
  let msg = {
    type: "ping",
    groupId: room,
    device_id: localStorage.getItem("device_no") || "",
  };
  msg = JSON.stringify(msg);
  let message = tim.createCustomMessage({
    to: "admin",
    conversationType: TIM.TYPES.CONV_C2C,
    payload: {
      data: msg,
    },
  });
  timSendMessage(message);
  pingTimer = setInterval(() => {
    timSendMessage(message);
  }, 60000);
}

function timSendMessage(message) {
  let promise = tim.sendMessage(message);
  promise
    .then((imResponse) => {
      if (imResponse.code == 0) {
        console.log(
          "timSendMessage ping 发送成功",
          JSON.parse(imResponse.data.message.payload.data)
        );
      }
    })
    .catch((imError) => {
      console.warn("timSendMessage ping 发送失败", imError);
    });
}
function loginRequest(room) {
  let msg;
  if (store.state.userInfo.id) {
    msg = { type: "login", groupId: room };
  } else {
    msg = { type: "first", groupId: room };
  }
  msg = JSON.stringify(msg);
  console.log(msg);
  let message = tim.createCustomMessage({
    to: "admin",
    conversationType: TIM.TYPES.CONV_C2C,
    payload: {
      data: msg,
    },
  });
  let promise = tim.sendMessage(message);
  promise
    .then((imResponse) => {
      if (imResponse.code == 0) {
        console.log("first or login 登录成功", imResponse);
      }
    })
    .catch((imError) => {
      console.warn("sendMessage error:", imError);
    });
}

export function timSendGift(msg) {
  let msgJson = JSON.stringify(msg);
  let message = tim.createCustomMessage({
    to: String(roomId),
    conversationType: TIM.TYPES.CONV_GROUP,
    payload: {
      data: msgJson,
    },
  });
  // 2. 发送消息
  let promise = tim.sendMessage(message);
  promise
    .then((imResponse) => {
      // 发送成功
      if (imResponse.code == 0) {
        console.log(imResponse, "礼物发送成功");
        timSendGiftRes(msg);
      }
    })
    .catch((imError) => {
      // 发送失败
      console.log("礼物发送失败", imError);
      Vue.prototype.$message.error(JSON.parse(imError.message).msg);
    });
}
function timSendGiftRes(msg) {
  msg.type = "giftFeed";
  msg = JSON.stringify(msg);
  let message = tim.createCustomMessage({
    to: "admin",
    conversationType: TIM.TYPES.CONV_C2C,
    payload: {
      data: msg,
    },
  });
  // 2. 发送消息
  let promise = tim.sendMessage(message);
  promise
    .then((imResponse) => {
      // 发送成功
      if (imResponse.code === 0) {
        console.log(imResponse, "礼物c2c发送成功");
      }
    })
    .catch((imError) => {
      // 发送失败
      console.log("礼物c2c发送失败", imError);
      Vue.prototype.$message.error(imError.message);
    });
}

function timSendGuess(msg) {
  msg = JSON.stringify(msg);
  console.log(msg, "timSendGuess");
  let message = tim.createCustomMessage({
    to: "admin",
    conversationType: TIM.TYPES.CONV_C2C,
    payload: {
      data: msg,
    },
  });
  // 2. 发送消息
  let promise = tim.sendMessage(message);
  promise
    .then((imResponse) => {
      // 发送成功
      if (imResponse.code == 0) {
        let data = JSON.parse(imResponse.data.message.payload.data);
        console.log(data, "发送成功 开奖");
      }
    })
    .catch((imError) => {
      //发送失败
      console.log("sendGuess error:", imError);
      Vue.prototype.$message.error(imError.message);
    });
}

let continuousGiftTimer = null;
function timOnMessageReceived(event) {
  console.log("onMessageReceived:::::::::::::::::", event);
  //识别是不是赛事页面
  if (window.location.pathname.indexOf("scheduleDetail") == 1) {
    event.data.forEach((item, index) => {
      if (item.payload.data != null) {
        //console.log("match_data ----->", item ,window.location.pathname);
        if (window.location.pathname.indexOf(item.payload.data.match_id) > 0) {
          store.commit("getMatchReceived", item);
        }
      }
    });
    return false;
  }

  //其它页面需要的数据
  const messageList = event.data;
  //临时过滤重复消息
  // let timMsg = store.state.timMessageReceived;
  // if (timMsg.find((e) => e.ID === messageList[0].ID) !== undefined) return;
  // store.commit("changeTimMessageReceived", [...timMsg, messageList[0]]);
  messageList.forEach((message) => {
    // 文字消息
    if (message.type === TIM.TYPES.MSG_TEXT) {
      let data = JSON.parse(message.cloudCustomData);
      data.textColor = data.props?.font_color ?? data.font_color;
      data.content = message.payload.text;
      data.from_client_name = message.nick;
      data.id = message.sequence;
      data.user_id = Number(message.from);
      data.type = "say";
      store.commit("pushMessageList", data);
      console.log(store.state.messageList, "text:: messageList");
    } else if (message.type === TIM.TYPES.MSG_CUSTOM) {
      let pic =
        "https://test-1301875615.cos.ap-beijing.myqcloud.com/images/2022031203413046507WhatsApp%20Image%202022-03-12%20at%2003.40.51.jpeg";
      let nowTime = Date.parse(new Date());
      let data = JSON.parse(message.payload.data);
      switch (data["type"]) {
        case "mgr_message_reply":
          console.log(data);
          data.content = window.decrypt(data.content, pic);
          data.chatType = 2;
          let userMsg = store.state.userMessageList;
          let userChatId = store.state.userChatId || 0;
          let chatList = store.state.chatList;
          if (userChatId !== data.sender_uid) {
            //未读消息加一
            console.log(userChatId, data.sender_uid, "未读消息加一");
            chatList.forEach((e) => {
              if (
                e.mgr_chat_user_id === data.sender_uid &&
                e.mgr_id === store.state.userInfo.id
              ) {
                e.unread_num += 1;
              }
              if (
                e.mgr_id === data.sender_uid &&
                e.mgr_chat_user_id === store.state.userInfo.id
              ) {
                e.unread_num += 1;
              }
            });
            store.commit("changeChatList", chatList);
          } else {
            let lastUserMsgTime = userMsg[userMsg.length - 1]?.send_time || 0;
            //相隔60秒添加时间线
            if (nowTime - lastUserMsgTime > 60000) {
              let timeData = {
                chatType: 3,
                time: nowTime,
                content: format(nowTime, "MM-dd hh:mm"),
              };
              store.commit("changeUserMessageList", [...userMsg, timeData]);
            }
            store.commit("changeUserMessageList", [...userMsg, data]);
          }
          //消息列表中没有新消息刷新列表
          let findMsg = chatList.find((e) => e.mgr_id === data.sender_uid);
          if (findMsg === undefined) {
            store.dispatch("getChatList");
          }
          break;
        case "sayRep":
          const resData = data.resp;
          resData.content = window.decrypt(resData.content, pic);
          resData.chatType = 2;
          resData.seq = resData.seq || message.sequence;
          let groupMsg = store.state.groupMessageList;
          let lastGroupMsgTime = groupMsg[groupMsg.length - 1]?.time || 0;
          let groupId = store.state.fanGroup.fans_group_id || "";
          let userId = store.state.userInfo.id || 0;
          //相隔60秒添加时间线
          if (
            nowTime - lastGroupMsgTime > 60000 &&
            groupId === resData.group_id &&
            resData.type === 0
          ) {
            let timeData = {
              chatType: 3,
              send_time: nowTime,
              content: format(nowTime, "MM-dd hh:mm"),
            };
            store.commit("changeGroupMessageList", [...groupMsg, timeData]);
          }
          //未读消息加一
          if (groupId !== resData.group_id && resData.type === 0) {
            let arr = store.state.chatList;
            arr.forEach((e) => {
              if (e.fans_group_id === resData.group_id) {
                e.unread_num += 1;
              }
            });
            store.commit("changeChatList", arr);
          }
          if (groupId === resData.group_id && resData.type === 0) {
            console.log("群聊提示", resData);
            store.commit("changeGroupMessageList", [...groupMsg, resData]);
          }
          if (groupId === resData.group_id && resData.type === 1) {
            console.log("加入群聊的提示", resData);
            resData.chatType = 3;
            if (resData.uid === userId) {
              resData.content = "您已加入群聊";
            } else {
              resData.content = resData.nick_name + " 加入群聊";
            }
            store.commit("changeGroupMessageList", [...groupMsg, resData]);
          }
          if (groupId === resData.group_id && resData.type === 2) {
            console.log("撤回", resData);
            let arr = groupMsg.filter((e) => e.seq !== resData.seq);
            arr.push({
              chatType: 3,
              content: resData.nick_name + " 已撤回一条消息",
            });
            store.commit("changeGroupMessageList", arr);
          }
          if (groupId === resData.group_id && resData.type === 3) {
            console.log("删除", resData);
            let arr = groupMsg.filter((e) => e.seq !== resData.seq);

            store.commit("changeGroupMessageList", arr);
          }
          if (groupId === resData.group_id && resData.type === 4) {
            console.log("被踢出", resData);
          }
          if (groupId === resData.group_id && resData.type === 5) {
            console.log("被禁言", resData);
            if (resData.uid === userId) {
              store.commit("pushToast", "您已被禁言");
            }
            let filterBannedMsg = groupMsg.filter((e) => e.uid !== resData.uid);
            store.commit("changeGroupMessageList", filterBannedMsg);
          }
          if (groupId === resData.group_id && resData.type === 7) {
            console.log("接受图片", resData);
            store.commit("changeGroupMessageList", [...groupMsg, resData]);
          }
          break;
        case "private_message_reply":
          data.content = window.decrypt(data.content, pic);
          data.chatType = 2;
          data.time = data.send_time;
          data.sender_uid = data.groupId;
          console.log("private", data);

          //未读消息加一
          let arr = store.state.chatList;
          if (
            !(
              store.state.anchorId === data.groupId &&
              store.state.isEnterPrivateChat
            )
          ) {
            arr.forEach((e) => {
              if (e.anchor_id === data.groupId && e.type === 1) {
                e.unread_num += 1;
              }
            });
            store.commit("changeChatList", arr);
          } else {
            let lastMsgTime =
              store.state.privateMessageList[
                store.state.privateMessageList.length - 1
              ]?.time || 0;
            //相隔60秒添加时间线
            if (nowTime - lastMsgTime > 60000) {
              let timeData = {
                chatType: 3,
                time: nowTime,
                content: format(nowTime, "MM-dd hh:mm"),
              };
              store.commit("pushPrivateMessageList", timeData);
            }
            store.commit("pushPrivateMessageList", data);
            store.dispatch("readPrivateChat", data.send_time);
          }
          break;
        case "heatRep":
          store.commit("changeHot", data.val);
          store.commit("changePlayerStatus", data.status);
          break;
        case "props":
          console.log(data, "props==================");
          if (data.props_type === 100) {
            data.isSpeaker = true;
            data.from_client_name = message.nick;
            store.commit("pushMessageList", data);
            return;
          }
          if (data.props_type === 101) {
            data.isColorful = true;
            if (data.props_id === 2) {
              data.textColor = store.state.colorfulTextColor[0];
            }
            if (data.props_id === 3) {
              data.textColor = store.state.colorfulTextColor[1];
            }
            if (data.props_id === 4) {
              data.textColor = store.state.colorfulTextColor[2];
            }
          }
          data.from_client_name = message.nick;
          data.id = message.sequence;
          data.user_id = Number(message.from);
          data.type = "say";
          store.commit("pushMessageList", data);
          break;
        case "attentAnchor":
          store.commit("pushMessageList", data);
          break;
        case "login":
          console.log(data, "welcome");
          if (data.vip_level > 0 || data.level > 9 || data.role > 1) {
            //最近三十条消息如果有欢迎消息，不在发送
            let isRepeatWelcome = false;
            const sliceArr = store.state.messageList.slice(-30);
            console.log(sliceArr, data, "wlecome");
            sliceArr.forEach((e) => {
              if (e.user_id === data.user_id && e.type === "login") {
                isRepeatWelcome = true;
              }
            });
            if (isRepeatWelcome) return;
            store.commit("pushMessageList", data);
          } else {
            store.commit("pushWelcomeMsg", data);
          }

          break;
        case "gift":
          console.log("gift======>", data);
          store.commit("toggleContinuousGift", true);
          clearTimeout(continuousGiftTimer);
          const gift = store.state.gifts[`gift_${data.giftid}`];
          data.icon = gift.icon;
          data.animation = gift.animation;
          data.animat_type = gift.animat_type;
          data.user_id = data.sender;
          store.commit("changeGiftAnimation", data);
          console.log("礼物消息", store.state.giftAnimation);
          let lastMsg =
            store.state.messageList[store.state.messageList.length - 1];
          if (data.hit > 1) {
            if (
              lastMsg.sender == data.sender &&
              lastMsg.giftid == data.giftid
            ) {
              store.commit("changeLastHitMessageList", data.hit);
            } else {
              store.commit("pushMessageList", data);
            }
          } else {
            store.commit("pushMessageList", data);
          }
          console.log("礼物消息", gift);
          store.commit("changeContinuousGift", data);
          continuousGiftTimer = setTimeout(() => {
            store.commit("toggleContinuousGift", false);
          }, 3000);
          break;
        case "bannedUser":
          // 删除被禁言用户的消息
          store.commit("deleteBannedMessageList", data.uid);
          if (data.mess === "") return;
          store.commit("pushMessageList", data);
          break;
        case "unbannedUser":
          // 如果自己被解除禁言
          if (data.uid === store.state.userInfo.id) {
            store.commit("toggleDisabledSendMsg", false);
            // 解除禁言之后重置风控次数
            localStorage.removeItem("t_vio");
            localStorage.removeItem("c_vio");
            localStorage.removeItem("n_vio");
          }
          //解除禁言通知
          if (data.mess === "") return;
          store.commit("pushMessageList", data);
          break;
        case "clearChat":
          //清除消息
          if (store.state.userInfo.id != data.user_id) {
            store.commit("deleteClearMessageList", data.chat_id);
            store.commit("changeDeleteMessageId", data.chat_id);
          }
          break;
        case "announcement":
          //直播间广告联系方式
          if (data.room_id === roomId) {
            store.commit("changeLiveAd", data.content);
            store.commit("changeLiveAdContact", JSON.parse(data.contact));
            JSON.parse(data.contact)?.forEach((e) => {
              if (e.title === "main_content") {
                store.commit("changeLiveAdContactMain", e.value);
              }
            });
          }
          break;
        case "guessSettled":
          //竞猜开奖通知
          console.log(data, "guessSettled");
          if (store.state.userInfo.id && store.state.userInfo.id !== roomId) {
            timSendGuess({
              type: "quizPrompt",
              guess_id: data.guess_id,
              groupId: roomId,
            });
          }
          break;
        case "quiz":
          //竞猜数据变动
          console.log(data, JSON.parse(data.message), "quiz");
          store.commit("changeGuessList", JSON.parse(data.message));
          break;
      }
    } else if (message.type === TIM.TYPES.MSG_GRP_SYS_NOTICE) {
      console.log("群系统通知", message.payload.groupProfile.to, message);
      if (Number(message.payload.groupProfile.to) === store.state.userInfo.id) {
        store.dispatch("getAnchorProfile", store.state.anchorId);
      }
    }
  });
}

function timOnMessageModified(event) {
  console.log(event.data, "onMessageModified:::::::::::::::::");
  //识别是不是赛事页面
  if (window.location.pathname.indexOf("scheduleDetail") == 1) {
    // onMatchDetailModified(event);
    store.commit("getMatchModified", event);
    return false;
  }
  //其它页面需要的数据
  const messageList = event.data;
  messageList.forEach((message) => {
    if (message.type === TIM.TYPES.MSG_CUSTOM) {
      let data = JSON.parse(message.payload.data);
      switch (data["type"]) {
        case "loginRep":
          console.log("loginRep::", data);
          store.commit("changeMessageList", []);
          store.commit("changeLoginRepData", data);
          if (data.data.guess !== "{}") {
            store.commit("changeGuessList", JSON.parse(data.data.guess));
          }

          data.data.chatHistory?.forEach((item) => {
            item.textColor = item.font_color;
            let props = item.rich ? JSON.parse(item.rich).props_id : 0;
            if (props == 2) {
              item.textColor = store.state.colorfulTextColor[0];
              item.isColorful = true;
            }
            if (props == 3) {
              item.textColor = store.state.colorfulTextColor[1];
              item.isColorful = true;
            }
            if (props == 4) {
              item.textColor = store.state.colorfulTextColor[2];
              item.isColorful = true;
            }
          });
          store.commit("changeMessageList", data.data.chatHistory);
          console.log(store.state.messageList, "MessageList");
          break;
        case "say":
          // 文字消息
          // store.commit("pushMessageList", data);
          break;
        case "gift":
          // 礼物消息
          const gift = store.state.gifts[`gift_${data.giftid}`];
          store.commit("toggleContinuousGift", true);
          clearTimeout(continuousGiftTimer);
          data.icon = gift.icon;
          data.animation = gift.animation;
          data.animat_type = gift.animat_type;
          data.user_id = data.sender;
          store.commit("changeGiftAnimation", data);
          console.log("礼物消息", store.state.giftAnimation);
          let lastMsg =
            store.state.messageList[store.state.messageList.length - 1];
          if (data.hit > 1) {
            if (
              lastMsg.sender == data.sender &&
              lastMsg.giftid == data.giftid
            ) {
              store.commit("changeLastHitMessageList", data.hit);
            } else {
              store.commit("pushMessageList", data);
            }
          } else {
            store.commit("pushMessageList", data);
          }
          store.commit("changeContinuousGift", data);
          continuousGiftTimer = setTimeout(() => {
            store.commit("toggleContinuousGift", false);
          }, 3000);
          break;
        case "giftFeedRep":
          let keyValue = {
            ...JSON.parse(localStorage.getItem("userInfo")),
            diamond: data.bal.diamond,
            gold: data.bal.gold,
          };
          localStorage.setItem("userInfo", JSON.stringify(keyValue));
          store.commit("changeUserInfo", {
            ...store.state.userInfo,
            diamond: data.bal.diamond,
            gold: data.bal.gold,
          });
          break;
        case "clearRep":
          //删除消息请求
          store.commit("deleteClearMessageList", data.chat_id);
          store.commit("changeDeleteMessageId", data.chat_id);
          store.commit("pushToast", i18n.t("live.deleteSuccess"));
          break;
        case "quizPrompt":
          //开奖消息
          console.log(data, "quizPrompt");
          store.commit("changeQuizPrompt", data);
          break;
      }
    }
  });
}
